import { classToPlain, Exclude, Expose, plainToClass, Transform } from "class-transformer";
import * as t from "io-ts";
import { validateJSON } from "../web/validation";
import { ActivityPeriodStatus, toActivityPeriodStatus } from "./activity-period-status";
import { getDatabaseCodeTransformer } from "./transfomers/transformers";

export const ActivityPeriodStatusTimeValidator = t.type({
  id: t.string,
  activityPeriodId: t.string,
  status: t.string,
  lastModifiedDttm: t.number,
  createDttm: t.number,
});

export const ActivityPeriodStatusTimeArrayValidator = t.array(
  ActivityPeriodStatusTimeValidator
);

export type ActivityPeriodStatusTime = t.TypeOf<
  typeof ActivityPeriodStatusTimeValidator
>;
export type ActivityPeriodStatusTimeArray = t.TypeOf<
  typeof ActivityPeriodStatusTimeArrayValidator
>;

@Exclude()
export class ActivityPeriodStatusTimeEntity {
  @Expose() id!: string;
  @Expose() activityPeriodId!: string;

  @Transform(getDatabaseCodeTransformer(toActivityPeriodStatus))
  @Expose()
  status!: ActivityPeriodStatus;

  @Expose() private createDttm!: number;
  @Expose() private lastModifiedDttm!: number;

  /**
   * Constructor for ActivityPeriodStatusTimeEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  /**
   * Create a ActivityPeriodStatusTimeEntity from a type value.
   *
   * @param activityPeriodStatusTime the type value.
   */
  static from(
    activityPeriodStatusTime: ActivityPeriodStatusTime
  ): ActivityPeriodStatusTimeEntity {
    const entity: ActivityPeriodStatusTimeEntity = plainToClass(
      ActivityPeriodStatusTimeEntity,
      activityPeriodStatusTime,
      {
        excludeExtraneousValues: true,
      }
    );
    return entity;
  }

  /**
   * Deserializes the ActivityPeriodStatusTimeEntity to a ActivityPeriodStatusTime type value.
   * If validation fails, the promise will be rejected.
   */
  toTypeValue(): Promise<ActivityPeriodStatusTime> {
    const object = classToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ActivityPeriodStatusTimeValidator, object);
  }

  get createDate(): Date {
    return new Date(this.createDttm);
  }

  get lastModifiedDate(): Date {
    return new Date(this.lastModifiedDttm);
  }
}
